import { useEffect, useRef, useState } from 'react';
import { isTauri } from '../utils/tauri';

// Desktop app polls less aggressively (5 min); the web app keeps the quicker 60s.
const WEB_POLL_INTERVAL = 60_000;
const DESKTOP_POLL_INTERVAL = 300_000;

export function useVersionCheck(): boolean {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialVersion = useRef<string | null>(null);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;

    const fetchVersion = async () => {
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`);
        if (!res.ok) return;
        const data = await res.json();
        const version = data.version as string;

        if (initialVersion.current === null) {
          initialVersion.current = version;
        } else if (version !== initialVersion.current) {
          setUpdateAvailable(true);
        }
      } catch {
        // Silently ignore fetch errors
      }
    };

    fetchVersion();
    const interval = isTauri() ? DESKTOP_POLL_INTERVAL : WEB_POLL_INTERVAL;
    timer = setInterval(fetchVersion, interval);

    return () => clearInterval(timer);
  }, []);

  return updateAvailable;
}
